var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monaco-editor"},[_c('div',{ref:"editorContainer",staticClass:"monaco-editor__container",class:{
			'monaco-editor__container--disabled': _vm.disabled
		}})])}
var staticRenderFns = []

export { render, staticRenderFns }